/* global twoFactorLoginUrl organisationsUrl mfaDeviceUsedUrl */

import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import Button from 'CommonComponents/Button';

export default function MfaСhallenge(props) {
    const [errorCode, setErrorCode] = useState(null);
    const [errorRecoveryCode, setErrorRecoveryCode] = useState(null);
    const [code, setCode] = useState('');
    const [recoveryCode, setRecoveryCode] = useState('');
    const [request, setRequest] = useState(false);

    const authWithCode = () => {
        setRequest(true);
        axios
            .post(props.twoFactorLoginUrl, { code })
            .then((res) => {
                setRequest(false);
                setErrorCode(null);
                deviceUsed();
            })
            .catch((e) => {
                setRequest(false);
                setErrorCode(e.response.data.message);
            });
    };

    const authWithRecoveryCode = () => {
        setRequest(true);
        axios
            .post(props.twoFactorLoginUrl, { recovery_code: recoveryCode })
            .then((res) => {
                setRequest(false);
                setErrorRecoveryCode(null);
                deviceUsed();
            })
            .catch((e) => {
                setRequest(false);
                setErrorRecoveryCode(e.response.data.message);
            });
    };

    const deviceUsed = () => {
        setRequest(true);
        axios
            .post(props.mfaDeviceUsedUrl, {})
            .then((res) => {
                setRequest(false);
                window.location.href = props.organisationsUrl;
            })
            .catch((e) => {
                setRequest(false);
                console.log(e.response);
            });
    };

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="accordion" id="twoFactorAuth">
                        <div className="card">
                            <div className="card-header" id="headingOne">
                                <h4 className="mb-0">
                                    <button
                                        className="link btn-block text-left"
                                        type="button"
                                        data-toggle="collapse"
                                        data-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                    >
                                        {$t('Two factor Authentication code')}
                                    </button>
                                </h4>
                            </div>

                            <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#twoFactorAuth">
                                <div className="card-body">
                                    <p className="text-center">{$t('Please enter your authentication code to login.')}</p>

                                    <div className="form-group row">
                                        <label htmlFor="code" className="col-md-4 col-form-label text-md-right">
                                            {$t('Authentication code:')}
                                        </label>

                                        <div className="col-md-6">
                                            <input
                                                id="code"
                                                type="code"
                                                className={`form-control ${errorCode ? 'is-invalid' : ''}`}
                                                name="code"
                                                required
                                                autoComplete="current-code"
                                                value={code}
                                                onChange={(e) => setCode(e.target.value)}
                                            />

                                            {!!errorCode && (
                                                <span className="invalid-feedback" role="alert">
                                                    <strong>{errorCode}</strong>
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="mb-0 form-group row">
                                        <div className="col-md-8 offset-md-4">
                                            <Button variant="primary" disabled={!code || request} onClick={authWithCode}>
                                                {$t('Submit')}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-header" id="headingTwo">
                                <h4 className="mb-0">
                                    <button
                                        className="link btn-block text-left collapsed"
                                        type="button"
                                        data-toggle="collapse"
                                        data-target="#collapseTwo"
                                        aria-expanded="false"
                                        aria-controls="collapseTwo"
                                    >
                                        {$t('Two factor Recovery Code')}
                                    </button>
                                </h4>
                            </div>
                            <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#twoFactorAuth">
                                <div className="card-body">
                                    <p className="text-center">{$t('Please enter your recovery code to login.')}</p>

                                    <div className="form-group row">
                                        <label htmlFor="recovery_code" className="col-md-4 col-form-label text-md-right">
                                            {$t('Recovery Code:')}
                                        </label>

                                        <div className="col-md-6">
                                            <input
                                                id="recovery_code"
                                                type="recovery_code"
                                                className={`form-control ${errorRecoveryCode ? 'is-invalid' : ''}`}
                                                name="recovery_code"
                                                required
                                                autoComplete="current-recovery_code"
                                                value={recoveryCode}
                                                onChange={(e) => setRecoveryCode(e.target.value)}
                                            />
                                            <span className="invalid-feedback" role="alert">
                                                <strong>{errorRecoveryCode}</strong>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="mb-0 form-group row">
                                        <div className="col-md-8 offset-md-4">
                                            <Button variant="primary" disabled={!recoveryCode || request} onClick={authWithRecoveryCode}>
                                                {$t('Submit')}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

if (document.getElementById('mfaChallenge')) {
    var rootEl = document.getElementById('mfaChallenge'); // data attributes below help us
    ReactDOM.render(
        <App>
            <MfaСhallenge twoFactorLoginUrl={twoFactorLoginUrl} organisationsUrl={organisationsUrl} mfaDeviceUsedUrl={mfaDeviceUsedUrl} />
        </App>,
        rootEl,
    );
}
